import { useState, useEffect } from "react";
import { PaymentFormContainer } from "./payment/form/PaymentFormContainer";
import { PaymentMethodsList } from "./payment/PaymentMethodsList";
import { usePaymentOperations } from "@/hooks/payment/usePaymentOperations";
import { PaymentFormData, PaymentType } from "@/types/payment";

interface ManagePaymentsProps {
  contactId: string;
}

export const ManagePayments = ({ contactId }: ManagePaymentsProps) => {
  const [showPaymentForm, setShowPaymentForm] = useState(false);

  const {
    isLoading,
    paymentMethods,
    fetchPaymentMethods,
    addPaymentMethod,
    deletePaymentMethod
  } = usePaymentOperations(contactId);

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const handlePaymentAction = () => {
    setShowPaymentForm(true);
  };

  const handleSubmit = async (formData: PaymentFormData) => {
    const paymentType = formData.cardNumber ? "credit" : "bank";
    const lastFour = paymentType === "credit" 
      ? formData.cardNumber.slice(-4) 
      : formData.bankNumber.slice(-4);

    const success = await addPaymentMethod({
      payment_type: paymentType as PaymentType,
      last_four: paymentType === "credit" ? lastFour : null,
      bank_last_four: paymentType === "bank" ? lastFour : null,
      card_expiry: formData.cardExpiry,
      card_cvv: formData.cardCvv,
    });

    if (success) {
      setShowPaymentForm(false);
      fetchPaymentMethods(); // Refresh the list after successful addition
    }
  };

  const handleDelete = async (id: string) => {
    const success = await deletePaymentMethod(id);
    if (success) {
      fetchPaymentMethods(); // Refresh the list after successful deletion
    }
  };

  if (!showPaymentForm) {
    return (
      <PaymentMethodsList
        paymentMethods={paymentMethods}
        isLoading={isLoading}
        onAddPayment={handlePaymentAction}
        onDeletePayment={handleDelete}
      />
    );
  }

  return (
    <PaymentFormContainer
      isLoading={isLoading}
      onSubmit={handleSubmit}
      onCancel={() => setShowPaymentForm(false)}
    />
  );
};